import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import Header from "./Header";
import Flightbot from "./Flightbot";
import Home from "./Home";
import Checkout from "./Checkout";
import Login from "./Login";
import Payment from "./Payment";
import Orders from "./Orders";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import iframe from "react-iframe";

const promise = loadStripe(
  "pk_test_51IHeQzAJryQF1Hezn0s7CwgqTyGtuHE8J78Hi0jdqsfr0XtKYNU3eGINGgivvnb3wgbHNMS6Mm9DSglwE8U6h1g600Wpdfpmcz"
);

function App() {
  const [{}, dispatch] = useStateValue();
  useEffect(() => {
    // will only run when the app component loads
    auth.onAuthStateChanged((authUser) => {
      console.log("the user is", authUser);
      if (authUser) {
        //user just logged in
        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/checkout">
            <Header />
            <Checkout />
          </Route>
          <Route path="/orders">
            <Header />
            <Orders />
          </Route>
          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>
          <Route path="/flight">
            <Header />
            <Flightbot />
          </Route>
          <Route path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
